"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsComponent = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const fab_button_1 = require("../../components/button/fab.button");
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const menu_1 = require("../../components/menu/menu");
const menu_item_1 = require("../../components/menu/menu.item");
const mithril_component_1 = require("../../components/mithril.component");
const spinner_1 = require("../../components/spinner/spinner");
const table_1 = require("../../components/table/table");
const theme_1 = require("../../components/theme");
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const userDisplayName_1 = require("../../util/userDisplayName");
const accounts_confirm_invite_1 = require("./accounts.confirm.invite");
const accounts_confirm_remove_1 = require("./accounts.confirm.remove");
const accounts_confirm_role_1 = require("./accounts.confirm.role");
const accounts_style_1 = require("./accounts.style");
(0, theme_1.addStyles)(accounts_style_1.Style);
class AccountsComponent extends mithril_component_1.IMithrilStateComponent {
    constructor(ctrl) {
        super();
        this.ctrl = ctrl;
        this.roleMenu = new menu_1.MenuComponent({
            items: () => [
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_ADMIN)),
                    action: () => this.confirmUserRoleChange(core_api_1.IkeUserRole.ROOT),
                    visible: true,
                    disabled: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.ROOT,
                    selected: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.ROOT,
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_USER)),
                    action: () => this.confirmUserRoleChange(core_api_1.IkeUserRole.USER),
                    visible: true,
                    divider: this.ctrl.haveExtraRoles(),
                    disabled: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.USER,
                    selected: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.USER,
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_VIEWER)),
                    action: () => this.confirmUserRoleChange(core_api_1.IkeUserRole.VIEWER),
                    visible: this.ctrl.haveExtraRoles(),
                    disabled: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.VIEWER,
                    selected: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.VIEWER,
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_EDITOR)),
                    action: () => this.confirmUserRoleChange(core_api_1.IkeUserRole.EDITOR),
                    visible: this.ctrl.haveExtraRoles(),
                    disabled: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.EDITOR,
                    selected: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.EDITOR,
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_DOWNLOADER)),
                    action: () => this.confirmUserRoleChange(core_api_1.IkeUserRole.DOWNLOADER),
                    visible: this.ctrl.haveExtraRoles(),
                    disabled: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.DOWNLOADER,
                    selected: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.DOWNLOADER,
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_DATA_ADMIN)),
                    action: () => this.confirmUserRoleChange(core_api_1.IkeUserRole.DATA_ADMIN),
                    visible: this.ctrl.haveExtraRoles(),
                    disabled: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.DATA_ADMIN,
                    selected: this.selectedUser && this.selectedUser.userLevel === core_api_1.IkeUserRole.DATA_ADMIN,
                },
            ],
        });
    }
    get nodes() {
        return (0, mithril_1.m)('div', { className: accounts_style_1.CSS.container }, [this.viewUsers(), this.viewAddButton()]);
    }
    setSelectedUser(user) {
        this.selectedUser = user;
    }
    confirmUserRoleChange(userRole) {
        const confirm = new accounts_confirm_role_1.AccountsConfirmRole(this.ctrl, this.selectedUser, userRole);
        confirm.open();
    }
    viewAddButton() {
        if (!this.ctrl.isDepartmentAdmin) {
            return null;
        }
        return fab_button_1.FabButton.view({
            title: index_1.T.ACCOUNTS_INVITE_TITLE,
            onclick: () => {
                const requestInviteComponent = new accounts_confirm_invite_1.AccountsInviteComponent(this.ctrl);
                requestInviteComponent.open();
            },
        });
    }
    viewUsers() {
        const headers = ['#', (0, index_1.Translate)(index_1.T.SIGNUP_EMAIL), (0, index_1.Translate)(index_1.T.ACCOUNTS_NAME), (0, index_1.Translate)(index_1.T.ACCOUNTS_ROLE)];
        const rows = [];
        const departmentUsers = this.ctrl.users;
        for (let i = 0; i < departmentUsers.length; i++) {
            const user = departmentUsers[i];
            rows.push(this.viewUser(user, i));
        }
        return table_1.Table.view((0, index_1.Translate)(index_1.T.ACCOUNTS_TITLE), headers, rows);
    }
    viewUser(user, index) {
        const displayName = (0, userDisplayName_1.userDisplayName)(user);
        return [
            (0, mithril_1.m)('span', { className: accounts_style_1.CSS.tableCell }, String(index + 1)),
            (0, mithril_1.m)('span', { className: accounts_style_1.CSS.tableCell }, user.username),
            (0, mithril_1.m)('span', { className: accounts_style_1.CSS.tableCellFaint }, displayName !== user.username ? displayName : ''),
            (0, mithril_1.m)('span', {}, this.viewRoleButton(user)),
            this.ctrl.isDepartmentAdmin ? this.viewRoleActions(user) : null,
        ];
    }
    viewRole(user) {
        const userLevel = this.getUserLevel(user);
        const roleTranslateKey = services_1.Services.UserProfile.isDepartmentAdmin(user) ? index_1.T.ROLE_ADMIN : index_1.T.ROLE_USER;
        if (userLevel) {
            return (0, mithril_1.m)('span', {}, userLevel);
        }
        return (0, mithril_1.m)('span', {}, (0, index_1.Translate)(roleTranslateKey));
    }
    viewRoleButton(user) {
        if (this.ctrl.isLoadingUser(user)) {
            return (0, mithril_1.m)('div', { className: accounts_style_1.CSS.tableCellRoleActions }, spinner_1.Spinner.view());
        }
        if (user.objectId === services_1.Services.User.current.objectId) {
            return [
                (0, mithril_1.m)('button', {
                    className: `${accounts_style_1.CSS.changeRole}  mdl-button mdl-js-button mdl-js-ripple-effect`,
                    style: { 'font-size': '13px' },
                    disabled: true,
                }, this.viewRole(user)),
            ];
        }
        if (!this.ctrl.isDepartmentAdmin) {
            return [
                (0, mithril_1.m)('button', {
                    className: `${accounts_style_1.CSS.changeRole}  mdl-button mdl-js-button mdl-js-ripple-effect`,
                    style: { 'font-size': '13px', color: '#000000' },
                    disabled: true,
                }, this.viewRole(user)),
            ];
        }
        return [
            (0, mithril_1.m)('button', {
                className: `${accounts_style_1.CSS.changeRole}  mdl-button mdl-js-button mdl-js-ripple-effect`,
                style: { 'font-size': '13px' },
                onclick: () => {
                    this.setSelectedUser(user);
                    this.roleMenu.show();
                },
            }, this.viewRole(user)),
            this.selectedUser && this.selectedUser.objectId === user.objectId ? this.roleMenu.view() : null,
        ];
    }
    getUserLevel(user) {
        if (services_1.Services.UserProfile.isDepartmentEditor(user)) {
            return (0, index_1.Translate)(index_1.T.ROLE_EDITOR);
        }
        if (services_1.Services.UserProfile.isDepartmentDownloader(user)) {
            return (0, index_1.Translate)(index_1.T.ROLE_DOWNLOADER);
        }
        if (services_1.Services.UserProfile.isDepartmentViewer(user)) {
            return (0, index_1.Translate)(index_1.T.ROLE_VIEWER);
        }
        if (services_1.Services.UserProfile.isDepartmentDataAdmin(user)) {
            return (0, index_1.Translate)(index_1.T.ROLE_DATA_ADMIN);
        }
        return null;
    }
    viewRoleActions(user) {
        if (this.ctrl.isLoadingUser(user)) {
            return (0, mithril_1.m)('div', { className: accounts_style_1.CSS.tableCellRoleActions }, spinner_1.Spinner.view());
        }
        const role = user.role;
        return (0, mithril_1.m)('div', { className: `${accounts_style_1.CSS.tableCellRoleActions} ${accounts_style_1.CSS.tableCellGhost}` }, [
            this.ctrl.canRemove(role) ? this.viewRemoveButton(user) : null,
        ]);
    }
    viewRemoveButton(user) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, {
            title: index_1.T.ACCOUNTS_REMOVE,
            onclick: () => {
                const confirm = new accounts_confirm_remove_1.AccountsConfirmRemove(this.ctrl, user);
                confirm.open();
            },
        });
    }
}
exports.AccountsComponent = AccountsComponent;
tslib_1.__decorate([
    mobx_1.observable
], AccountsComponent.prototype, "selectedUser", void 0);
tslib_1.__decorate([
    mobx_1.action
], AccountsComponent.prototype, "setSelectedUser", null);
//# sourceMappingURL=accounts.js.map